import { store } from "@betacrew/jars-flux";
import { all, put, takeLeading } from "redux-saga/effects";
import PaymentDataService from "../../../../../services/PaymentDataService";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { componentKey, setSelectedCard, setSelectedPaymentMode, setStripeCardDetails, setStripeSalesTax, setStripeSalexTaxCalculationSuccessfull, setStripeSavedCardsList, setZipCodeValidationSuccess } from "./AddFundsSlice";
import { PAYMENT_DRAWER_LOADING_STATES, PAYMENT_OPTIONS, PAYMENT_STEPS } from "../constants";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { setCurrentPaymentStep, setPaymentSuccessDetails, setLoadingState } from "../PaymentDrawerSlice";
import { getPrepayAmount } from "../PaymentDrawerSaga";
import GeneralDataService from "../../../../../services/GeneralDataService";
import General from "../../../../../libs/utility/General";

export const { getStripeSavedCards, getSavedCards, calculateSalesTaxForStripe, addPrepayBalance, validateZipCodeOnCardPage } = {

    getStripeSavedCards: (payload) => {
        return {
            type: "ADD_FUNDS/GET_STRIPE_SAVED_CARDS",
            payload
        }
    },

    getSavedCards: (payload) => {
        return {
            type: "ADD_FUNDS/GET_SAVED_CARDS",
            payload
        }
    },

    calculateSalesTaxForStripe: (payload) => {
        return {
            type: "STRIPE_SALES_TAX/CALCULATE",
            payload
        }
    },

    addPrepayBalance: (payload) => {
        return {
            type: "ADD_FUNDS/ADD_PREPAY_BALANCE",
            payload
        }
    },
    validateZipCodeOnCardPage: (payload) => {
        return {
            type: "ADD_FUNDS/VALIDATE_ZIP_CODE",
            payload
        }
    },
}

function* getSavedCardsAsync(action) {
    try {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.GET_SAVED_CARDS_LOADING }));

        const response = yield PaymentDataService.GetSavedCardsList();

        if (response?.data) {
            const { Status, Message, Data } = response?.data;

            if (Status) {
                if (Data) {
                    const selectedCard = Data.find(card => card.Selected);

                    const cardsList =  General.reorderArrayByActiveElementObj(Data , "Selected");
                    yield put(setStripeSavedCardsList(cardsList));
                    
                    yield put(setSelectedCard(selectedCard));
                    yield put(setSelectedPaymentMode(PAYMENT_OPTIONS[0]));
                } else {
                    yield put(setSelectedPaymentMode(PAYMENT_OPTIONS[1]));
                    yield put(setStripeSavedCardsList([]));
                }
            } else {
                yield put(addNotifications({ heading: "Failed to fetch the list of cards", message: Message }));
            }
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the list of cards", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.GET_SAVED_CARDS_READY }))
    }
}

function* getStripeSavedCardsAsync(action) {
    try {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.GET_SAVED_CARDS_LOADING }));

        const response = yield PaymentDataService.GetStripeCardDetailsById({cardId: action.payload.Value});

        if (response?.data) {
            const { Status, Message, Data } = response?.data;

            if (Status) {
                if (Data?.data && Data?.data?.length  && Object.keys(Data.data[0]).length) {
                    yield put(setStripeCardDetails(Data.data[0]));
                    yield put(setSelectedPaymentMode(PAYMENT_OPTIONS[0]));
                } else {
                    yield put(setSelectedPaymentMode(PAYMENT_OPTIONS[1]));
                    yield put(setStripeSavedCardsList([]));
                }
            } else {
                yield put(addNotifications({ heading: "Failed to fetch the list of cards", message: Message }));
            }
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the list of cards", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.GET_SAVED_CARDS_READY }))
    }
}

function* calculateSalesTaxForStripeAsync(action) {
    try {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.STRIPE_SAVED_CARDS_SALES_TAX_LOADING, message: "Calculating sales tax" }));

        const { Address, Country, State, City, ZIP, TotalAmount, UspsMailing, UspsAmount, SavedCardValue, isUsps, isSubscription, SubscriptionAmount, hideNotification } = action.payload;

        const requestPayload = {
            StreetAddress1: Address?.value,
            City: City?.value || "",
            State: State?.value,
            Zipcode: ZIP?.value,
            Country: Country?.value,
            TotalAmount: Number((TotalAmount).toFixed(2)), //this total doesn't contain the UspsMailing amount so we are not subtracting it from UspsAmount
            SavedCardValue: SavedCardValue || "",
            UspsMailing: UspsMailing || 0,
            isUsps: isUsps || false,
            isSubscription: isSubscription || false,
            UspsAmount: UspsAmount || 0,
            SubscriptionAmount: SubscriptionAmount || 0
        }

        const response = yield PaymentDataService.getSalesTaxAmount(requestPayload);

        if (response?.data) {
            const { Status, Message, Data } = response?.data;

            if (Status) {
                yield put(setStripeSalesTax(Data));
                yield put(setStripeSalexTaxCalculationSuccessfull(true));

                if (!hideNotification) {
                    yield put(addNotifications({ heading: "Sales tax calculated", message: Message, variant: TOASTER_VARIANT.SUCCESS }))
                }
            } else {
                yield put(setStripeSalexTaxCalculationSuccessfull(false));
                yield put(addNotifications({ heading: "Something went wrong, Failed to calculate the sales tax", message: Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }

    } catch (error) {
        console.error(error);
        yield put(setStripeSalexTaxCalculationSuccessfull(false));
        yield put(addNotifications({ heading: "Failed to calculate the sales tax", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.STRIPE_SAVED_CARDS_SALES_TAX_READY }))
    }
}

function* addPrepayBalanceAsync(action) {
    try {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.ADD_PREPAY_BALANCE_LOADING, message: "Adding Prepay Balance" }));

        const { card_id, amount, placeOfOriginforpayment, saveCardDetails, Customer, showAdminAmount, CardNumber, CommonCreditCardNumber } = action.payload;

        const requestPayload = {
            totalAmount: Number(amount),
            placeOfOriginforpayment: placeOfOriginforpayment,
            taxYear: "",
            CommonIsSavedCard: saveCardDetails,
            CommonSavedCard: null,
            CardNumber: CardNumber,
            PaymentMethodId: card_id,
            Customer_Id: Customer || "",
            Card_Id: card_id || "",
            showAdminAmount,
            CommonCreditCardNumber: CommonCreditCardNumber,
        }

        if (requestPayload?.Customer_Id) {
            delete requestPayload?.PaymentMethodId;
        } else {
            delete requestPayload?.Customer_Id;
            delete requestPayload?.Card_Id;
        }

        const response = yield PaymentDataService.addBalanceToPrepayWallet(requestPayload);

        if (response?.data) {
            const { Status, Message, Data } = response?.data;

            if (Status) {
                yield put(setPaymentSuccessDetails({ amountPaid: Number(amount), message: Message }))
                yield put(setCurrentPaymentStep(PAYMENT_STEPS.PAYMENT_SUCESS));
                yield put(getPrepayAmount());
            } else {
                yield put(addNotifications({ heading: "Failed to add the card", message: Message }));
            }
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to add the balance to the wallet", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.ADD_PREPAY_BALANCE_READY }))
    }
}

function* validateZipCodeOnCardPageAsync(action) {
    try {

        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.VALIDATING_ZIP_CODE_LOADING }))

        const { country, state, postal_code } = action.payload;

        if (country !== "US") {
            yield put(setZipCodeValidationSuccess(true));
            yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.VALIDATING_ZIP_CODE_READY }))
            return;
        }

        const data = {
            State: state,
            ZipCode: postal_code
        }

        const response = yield GeneralDataService.validateZipCode(data);

        if (response?.data?.Status) {
            yield put(setZipCodeValidationSuccess(true));
        } else {
            yield put(setZipCodeValidationSuccess(false));
            yield put(addNotifications({ heading: "Zip code validation failed", message: response?.data?.Message }));
        }
    } catch (error) {
        console.error(error);
        yield put(setZipCodeValidationSuccess(false));
        yield put(addNotifications({ heading: "Failed to validate the zip code", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.VALIDATING_ZIP_CODE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLeading(getStripeSavedCards().type, getStripeSavedCardsAsync),
        takeLeading(getSavedCards().type, getSavedCardsAsync),
        takeLeading(calculateSalesTaxForStripe().type, calculateSalesTaxForStripeAsync),
        takeLeading(addPrepayBalance().type, addPrepayBalanceAsync),
        takeLeading(validateZipCodeOnCardPage().type, validateZipCodeOnCardPageAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);